import React, { useState } from 'react';
import { contactPanelStyle } from './CampaignBriefStyles';
import AddContact from './CampaignContacts/AddContact';
import CampaignContactsTable from './CampaignContacts/CampaignContactsTable';
import { ReactComponent as IconPlus } from '../../../svg/Icon_Plus.svg';
import { ReactComponent as IconMinimise } from '../../../svg/Icon_Minus.svg';
import { sectionedPanelStyle, iconPlusMinimiseStyle } from '../CampaignStyles';

const CampaignContacts = ({ campaign, onChange, readOnly, contactRoles, setContactRoles }) => {
    const [open, setOpen] = useState(true);
    const [editingContact, setEditingContact] = useState();

    const handleEditClick = (contact) => {
        setEditingContact(contact);
    };

    const handleChange = (contacts) => {
        onChange(contacts);
        setEditingContact();
    };

    return (
        <div style={sectionedPanelStyle}>
            <div
                style={{
                    ...contactPanelStyle,
                    paddingRight: 19,
                    paddingBottom: 8
                }}
            >
                <span
                    style={{ fontSize: 15, fontWeight: 500, marginBottom: 17 }}
                >
                    {window.translate('Campaign Contacts')}
                </span>
                <span>
                    {open ? (
                        <>
                            <IconMinimise
                                height={19}
                                width={19}
                                style={iconPlusMinimiseStyle}
                                onClick={() => setOpen(!open)}
                            />
                        </>
                    ) : (
                        <>
                            <IconPlus
                                height={19}
                                width={19}
                                style={iconPlusMinimiseStyle}
                                onClick={() => setOpen(!open)}
                            />
                        </>
                    )}
                </span>
            </div>
            {open && (
                <div
                    style={{
                        ...contactPanelStyle,
                        paddingTop: 0,
                        flexDirection: 'column'
                    }}
                >
                    <AddContact
                        editingContact={editingContact}
                        campaign={campaign}
                        onChange={handleChange}
                        readOnly={readOnly}
                        contactRoles={contactRoles}
                        setContactRoles={setContactRoles}
                    />
                    <CampaignContactsTable
                        campaign={campaign}
                        onEdit={handleEditClick}
                        onDeleteClick={onChange}
                        readOnly={readOnly}
                    />
                </div>
            )}
        </div>
    );
};

export default CampaignContacts;
